import { createContext } from "react";
import { contextFunctionInit } from "sprint-common-web";

import { BucketArchiveItem, CreateBucketArchiveItem } from "../listing/BucketArchiveItem";

interface IBucketArchiveListingContext {
    bucketArchiveItems: BucketArchiveItem[];
    isLoading: boolean;
    addBucketArchiveItem(bucket: CreateBucketArchiveItem): void;
}

const defaultBucketArchiveListingContext: IBucketArchiveListingContext = {
    bucketArchiveItems: [],
    isLoading: false,
    addBucketArchiveItem: contextFunctionInit
};

export const BucketArchiveListingContext = createContext<IBucketArchiveListingContext>(
    defaultBucketArchiveListingContext
);
